/**
 * Date utility functions
 */

/**
 * Calculates age from a date of birth string
 * @param dateOfBirth - Date of birth in ISO string format (YYYY-MM-DD)
 * @returns Age in years, or null if dateOfBirth is empty/invalid
 */
export const calculateAge = (dateOfBirth: string): number | null => {
  if (!dateOfBirth) return null;

  const today = new Date();
  const birthDate = new Date(dateOfBirth);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // Adjust if birthday hasn't occurred this year
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};
